<box>
  <box-icon src="assets/svg/ressources/money-cash.svg"></box-icon>

  <box-number>2</box-number>

  <box-footer> Déterminez votre profil </box-footer>
</box>
